const articlCategory = {
  root: "catégorie",
  root_plural: "catégories",
};
export default articlCategory;
